import React from "react";
import { useSelector } from "react-redux";
import { LogoWrap } from "./style";

function Logo(props) {
  const { projectNamePoolName } = useSelector((state) => state.global);
  
  return (
    <LogoWrap small={props.small}>
      <img src={projectNamePoolName?.pool_url} />
    </LogoWrap>
  );
}

export default Logo;
